import type { OfflineStorage } from './OfflineStorage';

/**
 * Snapshots use a reserved `/__snapshot__/` key prefix that the service
 * worker must NOT intercept (these are read directly, not via fetch).
 */
export function snapshotKey(projectId: string, name: string): string {
  return `/__snapshot__/${projectId}/${name}.json`;
}

function jsonStream(value: unknown): ReadableStream<Uint8Array> {
  const bytes = new TextEncoder().encode(JSON.stringify(value));
  return new ReadableStream({ start(c) { c.enqueue(bytes); c.close(); } });
}

export async function putSnapshot(
  storage: OfflineStorage,
  projectId: string,
  name: string,
  value: unknown,
): Promise<void> {
  await storage.put(snapshotKey(projectId, name), jsonStream(value));
}

export async function getSnapshot<T = unknown>(
  storage: OfflineStorage,
  projectId: string,
  name: string,
): Promise<T | null> {
  const blob = await storage.get(snapshotKey(projectId, name));
  if (!blob) return null;
  return JSON.parse(await blob.text()) as T;
}
